import { Component, Prop, h } from '@stencil/core';

const COMPONENT_NAME = 'me-tag';

/**
 * Small pill-shaped label element for displaying keywords, categories, or status indicators.
 * Renders as a clickable link when `href` is provided, otherwise as a static inline element.
 *
 * @slot default - {required}, {content}, string
 * @example
 *   <me-tag href="/category">Marketing</me-tag>
 */
@Component({
  tag: 'me-tag',
  styleUrl: 'index.scss',
  shadow: false,
})
export class Tag {
  /**
   * If provided, the component renders as an <a> and becomes clickable.
   * If not provided, a <span> is used.
   */
  @Prop() href?: string;

  render() {
    const Tag = this.href ? 'a' : 'span';
    const classList = [COMPONENT_NAME].filter(Boolean).join(' ');

    return (
      <Tag class={classList} href={this.href} tabindex="0">
        <slot></slot>
      </Tag>
    );
  }
}
